<template>
  <div class="CompanyCreatedSuccess">
    <div
      class="icons-thumb-up"
      style="font-size: 90px;"
    />
    <h1
      class="Step Step__title h1 color-secondary"
    >
      {{ compiledText }}
    </h1>
  </div>
</template>
<script>
import marked from 'marked';

export default {
  props: {
    text: {
      required: true,
      type: String,
      default: '',
    },
  },
  computed: {
    compiledText() {
      return marked(this.text, { sanitize: true });
    },
  },
};
</script>

<style lang="scss">
.CompanyCreatedSuccess {
  h1 {
    padding-top: 25px;
  }
}
</style>
